module.exports = __webpack_public_path__ + "img/zjwm.4c89221b.png";